import React from 'react';

import appStorage from 'app-settings';

module.exports = React.createClass({
  propTypes: {
    tkey: React.PropTypes.string.isRequired,
    className: React.PropTypes.string
  },
  translate() {
    return appStorage.translationFunction(this.props.tkey);
  },
  render() {
    return <span className={this.props.className}>
      {this.translate()}
    </span>
  }
});



/** WEBPACK FOOTER **
 ** ./src/text/index.js
 **/